<div style="padding: 0 40px;height: 100%;overflow: auto">

  <div class="title-large" data-testid="title" style="margin-bottom: 32px;margin-top: 32px">
    Version history
  </div>

  @for (versionHistory of versionHistory|async; track versionHistory.version) {
    <div data-testid="historyCard" class="history-card">
      <div style="display: flex;justify-content: space-between">
        <span class="title-small">{{ versionHistory.version }}</span>
        <span class="label-large" style="color: var(--text-variant)">{{ versionHistory.date }}</span>
      </div>

      <div style="display: flex;gap: 8px;align-items:flex-start">
        <ul style="margin-top: 16px;flex: 1">
          @for (value of versionHistory.en; track value) {
            <li>{{ value }}</li>
          }
        </ul>
        <span data-testid="settingsButton" [matMenuTriggerFor]="menu" class="material-symbols-rounded" style="padding: 4px
          ;cursor: pointer;background: var(--card-background);border-radius: 66px;margin-top: 8px">more_vert</span>
        <mat-menu #menu="matMenu" class="test-me">
          <button data-testid="deleteButton" mat-menu-item (click)="deleteVersion(versionHistory)">Delete</button>
          <button data-testid="copyButton" mat-menu-item (click)="editVersion(versionHistory)">Copy</button>
        </mat-menu>
      </div>

    </div>
  }

</div>


<div
  style="display: flex;overflow: auto;flex-direction: column;position: relative; background: var(--card-background);height: 100%;position: relative">
  <div style="flex: 1; overflow: auto; padding: 0 40px">

    <div class="title-large" style="margin-bottom: 32px;margin-top: 32px">
      New version
    </div>

    <div style="display: flex; gap:16px ">
      <div class="form-group">
        <label>Version number</label>
        <input [(ngModel)]="versionNumber" data-testid="versionNumber">
      </div>

      <div class="form-group">
        <label>Displayed date</label>
        <input [(ngModel)]="date" data-testid="date">
      </div>
    </div>

    <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px;margin-top: 48px">
      <img height="24" ngSrc="assets/ic_sweden.svg" sizes="24" width="24">
      Swedish
    </div>
    <form [formGroup]="swedishForm">

      <div formArrayName="inputFields">
        @for (field of swedishInputFields.controls; let i = $index; track field) {
          <div [formGroupName]="i">
          <textarea data-testid="swedishDescription" style="display: block;margin-bottom: 24px"
                    formControlName="newInput"
                    placeholder="Add description"></textarea>
          </div>
        }
      </div>
    </form>


    <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px;margin-top: 48px">
      <img height="24" ngSrc="assets/ic_uk.png" sizes="24" width="24">
      English
    </div>

    <form [formGroup]="englishForm">


      <div formArrayName="inputFields">
        @for (field of englishInputFields.controls; let i = $index; track field) {
          <div [formGroupName]="i">
          <textarea data-testid="englishDescription" style="display: block;margin-bottom: 24px"
                    formControlName="newInput"
                    placeholder="Add description"></textarea>
          </div>
        }
      </div>
    </form>


    <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px;margin-top: 48px">
      <img height="24" ngSrc="assets/ic_norway.svg" sizes="24" width="24">
      Norwegian
    </div>

    <form [formGroup]="norwegianForm">


      <div formArrayName="inputFields">
        @for (field of norwegianInputFields.controls; let i = $index; track field) {
          <div [formGroupName]="i">
          <textarea data-testid="norwegianDescription" style="display: block;margin-bottom: 24px"
                    formControlName="newInput"
                    placeholder="Add description"></textarea>
          </div>
        }
      </div>
    </form>


    <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px;margin-top: 48px">
      <img height="24" ngSrc="assets/ic_germany.svg" sizes="24" width="24">
      German
    </div>

    <form [formGroup]="germanForm">


      <div formArrayName="inputFields">
        @for (field of germanInputFields.controls; let i = $index; track field) {
          <div [formGroupName]="i">
          <textarea data-testid="germanDescription" style="display: block;margin-bottom: 24px"
                    formControlName="newInput"
                    placeholder="Add description"></textarea>
          </div>
        }
      </div>
    </form>
  </div>

  @if (loading()) {
    <mat-spinner diameter="40"
                 style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"></mat-spinner>
  }


  <div class="fab-container">
    <div style="display: flex;gap: 8px;">
      <button (click)="addInputField()" class="secondary-button" data-testid="addFieldButton">Add field</button>
      <button (click)="deleteInputField()" class="secondary-button" data-testid="deleteFieldButton">Delete field
      </button>
      <button (click)="translate()" class="secondary-button" data-testid="autoTranslateButton">Auto translate</button>
    </div>
    <button (click)="saveVersion()"
            [disabled]="swedishForm.invalid || englishForm.invalid || germanForm.invalid || norwegianForm.invalid||versionNumber==''||date==''"
            class="primary-button"
            data-testid="saveVersionButton">
      Save version
    </button>
  </div>
</div>

